//
// Formularüberprüfungen
//

function init() {
    const toggleSection = document.querySelectorAll('.form-toggle-section');

    toggleSection.forEach(function (el) {
        const radioElements = el.querySelectorAll('input.form-section-toggle');
        const sectionDetail = el.querySelector('.form-toggle-section-detail');

        for (const radioElement of radioElements) {
            radioElement.addEventListener('click', function () {
                toggleFormSection(radioElement, sectionDetail);
            }, false);
            if (radioElement.checked && radioElement.value == "Ja") {
                sectionDetail.classList.remove('d-none');
            }
        }
    });
}

function toggleFormSection(radioElement, sectionDetail) {
    const requiredFields = sectionDetail.querySelectorAll('input');

    if (radioElement.checked && radioElement.value == "Ja") {
        sectionDetail.classList.remove('d-none');
        requiredFields.forEach(element => {
            element.required = true;
        });
    } else {
        sectionDetail.classList.add('d-none');
        requiredFields.forEach(element => {
            element.required = false;
        });
    }
}

export default {};

export const Init = init;
